import { AppDefinition } from '../../types/apps';


export const RIVER_DRIVE_APP_EVENTS = {
  FILE_OPEN: 'app:system:OPEN_FILE',
  FILE_OPEN_FROM_BROWSER: 'app:file:openFromBrowser',
  FILE_DELETE: 'app:file:delete',
  GET_FILE_LIST: 'app:system:GET_FILE_LIST',
  SHOW_FILE_LIST: 'app:system:SHOW_FILE_LIST',
  NOTE_OPEN: 'app:note:open',
  NOTE_DELETE: 'app:note:delete',
  WEB_OPEN: 'app:web:open',
  WEB_DELETE: 'app:web:delete',
  SPACE_OPEN: 'app:space:open',
  SPACE_DELETE: 'app:space:delete',
  COMMAND_PALETTE_OPEN: 'app:entityBrowser2:commandPalette:open',
  ENTITY_GROUP: 'app:entityBrowser2:entity:group',
  ENTITY_UNGROUP: 'app:entityBrowser2:entity:ungroup',
  ENTITY_DRAG_DROP: 'app:entityBrowser2:entity:dragDrop',
} as const;


export const RiverDriveAppDefinition: AppDefinition = {
  appId: 'entityBrowser2',
  name: 'Drive',
  version: '2.0.0',
  description: 'Modern Linear-inspired entity browser with advanced features, hotkeys, and drag & drop support',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'HardDrives',
    phosphorWeight: 'duotone',
    metadata: {
      source: 'app',
      appId: 'entityBrowser2',
      isAppIcon: true
    }
  },
  events: RIVER_DRIVE_APP_EVENTS,
  entityTypes: ['File', 'Note', 'WebDocument', 'Space', 'AppleNote', 'Group', 'Thread', 'Message'],
  component: 'EntityBrowserApp2',
  requiresProps: false,
  requiresEntity: true,
  hotkeys: {
    'cmd+k': 'openCommandPalette',
    'cmd+f': 'focusSearch',
    'cmd+1': 'switchToListView',
    'cmd+2': 'switchToGridView',
    'cmd+j': 'toggleSidebar',
    'cmd+g': 'createGroup',
    'cmd+a': 'selectAll',
    'escape': 'clearSelection',
  },
  features: [
    'Modern Linear-inspired UI',
    'List and Grid view modes',
    'Advanced search and filtering',
    'Multi-select with Cmd/Ctrl+click and Shift+click',
    'Entity grouping with Cmd+G',
    'Select all with Cmd+A',
    'Drag & drop support',
    'Command palette (⌘K)',
    'Comprehensive keyboard shortcuts',
    'Detailed entity information panel',
    'Responsive design',
    'Fast interaction speed',
    'Real-time collaboration',
    'Professional animations',
    'Touch-friendly mobile support',
  ],
};

export default RiverDriveAppDefinition; 